import React from 'react'
import { Link } from 'gatsby'
import GoldenCircleGraphic from './GoldenCircleGraphic'

import './style.scss'

const GoldenCircle = () => {
  const cols = [
    {
      title: 'Why',
      text:
        'Data is an asset which can unlock unseen opportunities for improved performance, innovation and competitiveness. We want to inspire and enable businesses to unlock the value of their data and use it to achieve more. We also believe that the way to do this is not by handing over to data scientists but by augmenting and updating the skillsets of professionals and subject matter experts.',
      link: '/learn',
      linkLabel: 'Our applications',
      color: '#1CB279',
    },
    {
      title: 'What',
      text:
        'We help businesses become data-driven and turn their data into a system to engineer success again and again, guiding them towards an embedded internal end-to-end capability and data culture.',
      link: '/contact',
      linkLabel: 'Partner with us',
      color: '#F6A85B',
    },
    {
      title: 'How',
      text:
        '1. We help organizations solve business and industrial challenges with data science consulting and analytics. 2. We develop enabling technology - fully automated machine learning-based analytics tools for professionals without data science experience. 3. We deliver data-literacy training and change management support to cultivate teams with a data-driven mindset.',
      link: '/products',
      linkLabel: 'Our offering',
      color: '#EA1362',
    },
  ]

  return (
    <section>
      <div className="container px-md-5 position-relative mb-3 mb-sm-5">
        <div className="row">
          <div className="col-sm-8">
            <h6>Why, what and how</h6>
            <h2>
              DataStories
              <br /> Golden Circle
            </h2>
          </div>
        </div>
        <GoldenCircleGraphic />
        <div className="row">
          {cols.map(col => (
            <div className="col-sm-4 c-golden-circle-feature" key={col.title}>
              <h3 style={{ color: col.color }}>{col.title}</h3>
              <p>{col.text}</p>
              <Link style={{ color: col.color }} to={col.link}>
                {col.linkLabel}
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default GoldenCircle
